import React, { useState } from "react";
import { Tooltip, IconButton } from "@mui/material";
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalBody,
} from "@chakra-ui/modal";
import Card from "components/card";
import { Button } from '@chakra-ui/react';
import { MdOutlineContentCopy, MdInfoOutline } from "react-icons/md";

const AccountResetPostbackSecretSuccessModal: React.FC<{
    details: any;
    isOpen: boolean;
    onClose(): void;
    triggerReload(): void;
}> = ({ details, isOpen, onClose, triggerReload }) => {

    const [isCopied, setIsCopied] = useState<boolean>(false);

    const closeModal = async () => {
        triggerReload();
        setIsCopied(false);
        onClose();
    };

    const handleClickCopy = async (secret: string) => {
        try {
            setIsCopied(true);
            await navigator.clipboard.writeText(secret);
        } catch (err) {
            console.error('Failed to copy: ', err);
        }
    };

    return (
        <>
            {details &&
                <Modal isOpen={isOpen} onClose={onClose} closeOnOverlayClick={false}>
                    <ModalOverlay className="bg-[#000] !opacity-30" />
                    <ModalContent className="!z-[1002] !m-auto !w-max min-w-[250px] !max-w-[85%] md:top-[12vh]">
                        <ModalBody className="!text-navy-700">
                            <Card extra="px-[30px] pt-[35px] pb-[40px] max-w-[650px] flex flex-col !z-[1004] text-center">
                                <h1 className="mb-[20px] text-2xl font-bold">Webhook Secret has been reset</h1>
                                <div className="mb-[20px] text-sm text-center">
                                    <div className="mb-3">
                                        A new Webhook Secret has been generated. For security reasons, it will only be fully visible once. Please copy and store it securely.
                                    </div>
                                    <div className="p-3 border-2 border-red-600 mb-3">
                                        <div className="mb-3 font-bold text-red-600 flex items-center justify-center gap-2">
                                            <MdInfoOutline className="h-6 w-6" />
                                            The subaccount is now using this new Webhook Secret.
                                        </div>
                                        <div className="mb-3 font-bold text-red-600">
                                            After this, the secret will be masked and cannot be revealed again.
                                        </div>
                                    </div>
                                    <div className="mb-3">
                                        Make sure to copy the secret before continuing.
                                    </div>
                                    <div className="mb-3 flex w-full max-w-md mx-auto items-center gap-2">
                                        <input
                                            type="text"
                                            value={details.postback_secret}
                                            readOnly
                                            className="custom-readonly flex h-10 w-full text-primary rounded-md border border-gray-300 bg-white p-4 shadow-sm outline-none !cursor-pointer"
                                        />
                                        <Tooltip title="Copy Webhook Secret" arrow placement="top">
                                            <IconButton
                                                id="button-copy-postback-secret"
                                                onClick={() => handleClickCopy(details.postback_secret)}
                                            >
                                                <MdOutlineContentCopy className="h-6 w-6 text-navy-800" />
                                            </IconButton>
                                        </Tooltip>
                                    </div>
                                </div>
                                <div className="flex gap-2 justify-center">
                                    <Button
                                        onClick={() => closeModal()}
                                        disabled={!isCopied}
                                        className="btn btn-default"
                                    >
                                        Close
                                    </Button>
                                </div>
                            </Card>
                        </ModalBody>
                    </ModalContent>
                </Modal>
            }
        </>
    );
};

export default AccountResetPostbackSecretSuccessModal;
